import { ContainerButton } from './styles';
import { Button, ButtonProps } from 'antd';

interface IButtonProps extends ButtonProps {
  children?: React.ReactNode | string;
}

export const AButton: React.FC<IButtonProps> = ({ children, ...res }) => {
  return (
    <ContainerButton>
      <Button {...res}>{children}</Button>
    </ContainerButton>
  );
};
